import axios from 'axios';

export const requestChangeTfaType = () => axios.post('/user/request_change_tfa_type/');
export const resetTfaType = data => axios.post('/user/reset_tfa_type/', { ...data });
export const setTfaType = data => axios.post('/user/set_tfa_type/', { ...data });
export const verifyTfaType = data => axios.post('/user/verify_tfa_type/', { ...data });
export const verifyWithdrawalRequest = (id, data) => axios.post(`/payments/v2/${id}/verify/`, { ...data });
export const verifyWithdrawalResend = id => axios.post(`/payments/v2/${id}/verify_resend/`);
